export enum ProductType {
  Undefined = 0,
  Log = 1,
  Coil = 2,
  Bulk = 3,
  Dimension = 4,
}
